export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 11
	},
	name: "delier2",
	day: 2,
	date: {
		time: "09:33",
		day: "scene.date.text" 
	},
	patientState: 0,
	delirium: {
		initialState: "groen",
		clockPosition: {
			x: 784,
			y: 187
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_nacht_ochtend_blinds-dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_nacht_ochtend_blinds-dicht_di.flv"
			}
		],
		roomViewToggleButtonPosition: {
			x: 1265,
			y: 238
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier2/delier2_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier2/delier2_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier2/delier2_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier2/delier2_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 781,
			y: 188
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier2/${locale}/delier_2_slot_blinds_dicht_wo.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier2/${locale}/delier_2_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier2/${locale}/delier_2_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier2/${locale}/delier_2_slot_blinds_open_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 1,
				url: "delier2/${locale}/delier_2_slot_blinds_open_wo.flv"
			},
		]
	},
	transitions: [
		{
			deliriumState: "wit",
			target: "delier5"
		},
		{
			deliriumState: "groen",
			target: "delier5"
		},
		{
			deliriumState: "oranje",
			target: "delier6"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier2/${locale}/delier_2_dialoog_startloop.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientlatenslapen",
			value: "delier2/${locale}/delier_2_dialoog_latenslapen.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientvragennaardenacht",
			value: "delier2/${locale}/delier_2_dialoog_doorvrhallucinatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier2/${locale}/delier_2_dialoog_dag.flv"
		}
	]
}